import Highcharts from 'highcharts';

export const figure46 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 320,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#ed7d31', '#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
      "Mundo",
      "",
      "Australia y Nueva Zelandia",
      "Europa y América del Norte",
      "África septentrional y Asia occidental",
      "América Latina y el Caribe",
      "Asia oriental y sudoriental",
      "Asia central y meridional",
      "Oceanía (excluidas Australia y Nueva Zelandia)",
      "África subsahariana",
      "",
      "Países menos adelantados (PMA)",
      "Pequeños Estados insulares en desarrollo (PEID)",
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      //format: '{value}%',
      format: '{value}',
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    max: 5,
    min: 0,
    tickInterval: 1,
    gridLineWidth: 2,
    title: {
      text: "Nivel medio de ejecución: 1 más bajo - 5 más alto",
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '2018',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [3, null, 3, 4, 4, 4, 4, 3, 4, 4, null, 4, 4]
  },{
    name: '2020',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [4, null, 0, 4, 5, 4, 4, 2, 4, 4, null, 4, 4]
  }]
};